import { ref, watch } from 'vue'

export function useDisabledDate(paramStartDate = null, paramEndDate = null) {
  const start_date = ref(paramStartDate) // object momentjs
  const end_date = ref(paramEndDate)
  const startDate = ref() // string sesuai backend server yyyy-mm-dd
  const endDate = ref()
  const firstDayMonth = ref() // string awal bulan tgl 1
  const lastDayMonth = ref()

  const disabledStartDate = start_date => {
    if (!start_date || !end_date.value) {
      return false
    }

    return start_date.valueOf() > end_date.value.valueOf()
  }

  const disabledEndDate = end_date => {
    if (!end_date || !start_date.value) {
      return false
    }

    return start_date.value.valueOf() >= end_date.valueOf()
  }

  const format = yourDate => {
    if (!yourDate) return

    const offset = yourDate.getTimezoneOffset()
    yourDate = new Date(yourDate.getTime() - offset * 60 * 1000)
    return yourDate.toISOString().split('T')[0]
  }

  const getFirstDayMonth = value => {
    const d = new Date(value)
    const startDated = new Date(d.getFullYear(), d.getMonth(), 1)

    return format(startDated)
  }

  const getLastDayMonth = value => {
    const d = new Date(value)
    const dated = new Date(d.getFullYear(), d.getMonth() + 1, 0)

    return format(dated)
  }

  watch(start_date, () => {
    // console.log('start_date', start_date.value)
    if (start_date.value === null || start_date.value === undefined) {
      firstDayMonth.value = null
      startDate.value = null
      return
    }
    const d = new Date(start_date.value)
    const startDated = new Date(d.getFullYear(), d.getMonth(), 1)

    firstDayMonth.value = format(startDated)
    startDate.value = format(d)
  })

  watch(end_date, () => {
    if (end_date.value === null || end_date.value === undefined) {
      lastDayMonth.value = null
      endDate.value = null
      return
    }
    const d = new Date(end_date.value)
    const date = new Date(d.getFullYear(), d.getMonth() + 1, 0)

    lastDayMonth.value = format(date)
    endDate.value = format(d)
  })

  const disabledStartDated = (current, end_date) => {
    if (!current || !end_date) {
      return false
    }

    return current.valueOf() > end_date.valueOf()
  }

  const disabledEndDated = (start_date, current) => {
    if (!current || !start_date) {
      return false
    }

    return start_date.valueOf() >= current.valueOf()
  }

  return {
    start_date,
    end_date,
    startDate,
    endDate,
    disabledStartDate,
    disabledStartDated,
    disabledEndDate,
    disabledEndDated,
    firstDayMonth,
    lastDayMonth,
    format,
    getFirstDayMonth,
    getLastDayMonth,
  }
}
